import { createContext } from 'react'

export const SelectContext = createContext()

export const SelectFocusContext = createContext()
